import { IOrderPendingServiceMock } from "./order.types";

export const mockOrderPendingService = (): IOrderPendingServiceMock => ({
  getPendingOrders: jest.fn(),
  getExpiredOrders: jest.fn(),
  getPendingSendOrders: jest.fn(),
  updateOrderSendStatus: jest.fn(),
});
